<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-phone"
      v-model="model"
      :error="errors"
      type="phone"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required|min:10' : 'min:10'"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "Phone",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('phone')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultLabel: this.$t("Phone")
    }
  }
}
</script>

<style scoped>

</style>
